import DragablePanel from './DragablePanel';

export default DragablePanel;
